// IQ Test — production IQ scoring configuration (team-confirmed fixed
// Mean=40.5/SD=7.8 raw-score norm). `items`/`sectionItems` reuse
// iq-assessment-config.js's constants so question counts are defined in
// exactly one place.

import { TOTAL_QUESTIONS, QUESTIONS_PER_DOMAIN } from "./iq-assessment-config";

export const IQ_SCORING_CONFIG = {
  items: TOTAL_QUESTIONS,
  sectionItems: QUESTIONS_PER_DOMAIN,
  rawMean: 40.5,
  rawSd: 7.8,
  iqMean: 100,
  iqSd: 15,
  iqFloor: 55,
  iqCeil: 145,
};

// 7-band Wechsler-style descriptive classification for the IQ/deviation
// index (mean 100/SD 15) — a pure bucketing of an already-computed
// IQ-scale number. Distinct vocabulary/scale from the 5-band PERCENTAGE
// performance system (iq-assessment-config.js's OFFICIAL_PERFORMANCE_BANDS)
// — never merge or cross-reference the two.
export const PSYCHOMETRIC_CLASSIFICATION_BANDS = [
  { key: "extremely_low", label: "Extremely Low", min: -Infinity, max: 69 },
  { key: "very_low", label: "Very Low", min: 70, max: 79 },
  { key: "low_average", label: "Low Average", min: 80, max: 89 },
  { key: "average", label: "Average", min: 90, max: 109 },
  { key: "high_average", label: "High Average", min: 110, max: 119 },
  { key: "very_high", label: "Very High", min: 120, max: 129 },
  { key: "extremely_high", label: "Extremely High", min: 130, max: Infinity },
];
